// extracted by mini-css-extract-plugin
module.exports = {"download":"ImportStockCreate_download__10kZV","actions":"ImportStockCreate_actions__37-Mt"};